// Rename file to studentSelectors.ts and update content
import { RootState } from '../index';

export const selectStudents = (state: RootState) => state.students.students;
export const selectSelectedStudent = (state: RootState) => state.students.selectedStudent;
export const selectStudentsCount = (state: RootState) => state.students.studentsCount;
export const selectTotalStudentCount = (state: RootState) => state.students.studentsCount; // Better naming
export const selectStudentsLoading = (state: RootState) => state.students.loading;
export const selectStudentsError = (state: RootState) => state.students.error;
export const selectIsMobileClassroom = (state: RootState) => state.students.isMobileClassroom;